var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 53"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#136b8d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7 29.7v-.2c0-1-.8-1.8-1.8-1.8-.8 0-1.4.5-1.7 1.1 0 .1-.1.1-.1.2v.1c-1.5 7.9-9.3 13.2-17.3 11.7-5.6-1.1-11.4-6-11.9-13.7-.3-5.7 2.9-11.7 8.9-14.3 4.2-1.6 8.2-1.4 12.2.3.3.1.6.2.9.1 1-.1 1.7-.8 1.7-1.8 0-.8-.6-1.5-1.3-1.7-6.2-2.7-14-2.2-20 3.1-6.2 5.5-7.8 15-3.7 22.5s12.9 11.2 21.1 8.8c7.9-2.2 12.2-8.8 13-14.4z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.6l-4.3-4.3c-.6-.6-1.7-.7-2.3-.1-.7.7-.7 1.8-.1 2.5l6.8 6.8c.7.7 1.7.7 2.4 0 5.7-5.4 11.4-10.9 17.1-16.4.7-.7.7-1.8 0-2.5l-.2-.2c-.7-.6-1.7-.6-2.3 0-4.9 4.7-9.8 9.3-14.7 14.1-.7.8-1.8.8-2.4.1z",
    fill: "#f7b817"
  })));
};
export default __webpack_public_path__ + "static/media/support.8d31d028.svg";
export { SvgSupport as ReactComponent };